// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1pXne","savePackageButton":"ClientWallet_savePackageButton__1UMNc"};